import create from 'zustand';

interface EditScreenStore {
  isEditMode: boolean;
  isReviewMode: boolean;
  setIsScreenInEditMode: (isEditMode: boolean) => void;
  setIsScreenInReviewMode: (isReviewMode: boolean) => void;
}

export const useEditScreenStore = create<EditScreenStore>((set) => ({
  isEditMode: false,
  isReviewMode: false,
  setIsScreenInEditMode: (isEditMode: boolean) => set(() => ({ isEditMode })),
  setIsScreenInReviewMode: (isReviewMode: boolean) =>
    set(() => ({ isReviewMode })),
}));
